import { nanoid } from 'nanoid';

import { getCookie, MIXPANEL_SESSION, setCookie } from '../../utils/cookie';
import { hostUrl } from '../../utils/getServerUrl';

export const get_Session_id = () => {
  return 'prophecy-' + nanoid(10);
};

export const getNameFromEmail = (email: string) => email.split('@')?.[0];

export const MIXPANEL___TOKEN = 'c1bf58f29206c58a3cfb97ec539d7635';

export const FullStoryAllowedDomains = [
  'app.prophecy.ai',
  'sass.prophecy.ai',
  'acxiom.app.prophecy.ai',
  'beta.app.prophecy.io',
  'onboarding.dev.cloud.prophecy.io',
  'app.prophecy.io',
  'uitesting.prophecy.io',
  'cz.app.prophecy.io',
  'czdev.app.prophecy.io',
  'zionsbank.app.prophecy.io',
  'flexera.app.prophecy.io',
  'ai.cloud.prophecy.io',
  'cwan.app.prophecy.io',
  'beta.prophecy.io'
];
export const fullStoryNameSpace = 'prophecy_ff';
export const fullStoryOrgID = 'o-1HYGPZ-na1';

export const getMixpanelApIhost = () => {
  return `${hostUrl}/api/mp`;
};

export const getCurrentTimeStamp = () => {
  return String(new Date().getTime() / 1000);
};

export const MIXPANEL_ALLOWED_HOSTS = ['app.prophecy.io', 'app.prophecy.ai'];

export const getSessionValue = () => {
  let currentSession = getCookie(MIXPANEL_SESSION);
  if (!currentSession) {
    currentSession = get_Session_id();
    if (typeof window !== 'undefined' && MIXPANEL_ALLOWED_HOSTS.includes(window.location.host)) {
      setCookie(MIXPANEL_SESSION, currentSession, 30);
    }
  }
  return currentSession;
};
